export default {
  server: {
    url: '/api',
  },
};



// WEBPACK FOOTER //
// ./src/configs.js